module.exports = __webpack_public_path__ + "fonts/Luscious-Lifestyles-Sans.b71a6c0e.ttf";